import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-purple/30 to-transparent" data-id="element-235" />

      <section className="relative py-32 px-6 bg-hero-gradient overflow-hidden flex items-center justify-center text-center" data-id="element-236">
        {/* Animated Gradient Mesh Background */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-237">
          <div className="absolute top-0 left-0 w-full h-full bg-dark-bg/50" data-id="element-238" />
          <motion.div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple/30 rounded-full blur-[100px]" animate={{
          x: [0, 50, 0],
          y: [0, 30, 0]
        }} transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-239" />
          <motion.div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-teal/20 rounded-full blur-[100px]" animate={{
          x: [0, -40, 0],
          y: [0, -50, 0]
        }} transition={{
          duration: 10,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-240" />
        </div>

        {/* Floating Particles */}
        {[...Array(4)].map((_, i) => <motion.div key={i} className="absolute w-2 h-2 bg-white/20 rounded-full pointer-events-none" style={{
        left: `${20 + i * 20}%`,
        top: `${30 + i * 15}%`
      }} animate={{
        y: [0, -30, 0],
        opacity: [0.2, 0.5, 0.2]
      }} transition={{
        duration: 3 + i,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: i * 0.5
      }} data-id="element-241" />)}

        <div className="inner-container relative z-10 max-w-3xl" data-id="element-242">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-243">
            <h2 className="font-poppins font-extrabold text-5xl md:text-6xl mb-6 leading-tight" data-id="element-244">
              Ready to get your life back?
            </h2>
            <p className="text-xl md:text-2xl text-steel mb-10 font-inter" data-id="element-245">
              MIndSTReam.ing — Your business, running itself.
            </p>

            <button className="btn-primary text-lg px-10 py-5 mb-6 shadow-[0_0_40px_rgba(124,58,237,0.4)] hover:shadow-[0_0_60px_rgba(124,58,237,0.6)] transition-shadow" data-id="element-246">
              Talk to MR Now →
            </button>

            <p className="text-sm text-steel/70 font-medium" data-id="element-247">
              No contracts. No setup fees. Strategy call included.
            </p>
          </motion.div>
        </div>
      </section>
    </>;
}